export default __webpack_public_path__ + "images/a61b2075372b6a0fb4d1e148f0621b93-2_mobile_659x494.webp";